import { FunctionComponent } from 'preact';
import { useConfig } from '../providers/ConfigProvider';
import { useUnifiedWidget } from '../providers/UnifiedWidgetProvider';
import CloseIcon from '../icons/Close';

export const PopupMessage: FunctionComponent = () => {
  const { config } = useConfig();
  const { open, toggleWidget, gooberCss, showPopupMessage, hidePopup, agentInfo } = useUnifiedWidget();

  if (!config.popupMessage || !showPopupMessage || open) {
    return null;
  }

  const hide = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    hidePopup();
  };

  const avatar = agentInfo?.avatar;
  const name = agentInfo?.agent_name;

  return (
    <div
      className={gooberCss({
        position: "relative",
        maxWidth: "300px",
        animation: "popupIn 0.2s cubic-bezier(0.20, 1.35, 0.22, 1) both",
        "@keyframes popupIn": {
          "0%": {
            opacity: 0,
            transform: "translateY(8px) scale(0.95)",
          },
          "100%": {
            opacity: 1,
            transform: "translateY(0) scale(1)",
          }
        },
      })}
    >
      <button
        type="button"
        onClick={toggleWidget}
        className={gooberCss({
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          width: "100%",
          textAlign: "left",
          font: "inherit",
          color: "inherit",
          background: "#ffffff",
          border: "none",
          borderRadius: "16px",
          padding: "16px 36px 16px 16px",
          boxShadow: "0 6px 24px rgba(0, 0, 0, 0.16)",
          cursor: "pointer",
          "&:focus-visible": {
            outline: "2px solid currentColor",
          },
        })}
      >
        {avatar && (
          <img
            src={avatar}
            alt=""
            className={gooberCss({
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              objectFit: "cover",
              flexShrink: 0,
            })}
          />
        )}
        <div className={gooberCss({ minWidth: 0 })}>
          {name && (
            <div className={gooberCss({
              fontSize: "13px",
              fontWeight: 600,
              lineHeight: 1.3,
              marginBottom: "2px",
            })}>
              {name}
            </div>
          )}
          <div className={gooberCss({
            fontSize: "15px",
            lineHeight: 1.4,
            whiteSpace: "pre-line",
          })}>
            {config.popupMessage}
          </div>
        </div>
      </button>
      <button
        type="button"
        onClick={hide}
        aria-label="Dismiss message"
        className={gooberCss({
          position: "absolute",
          top: "8px",
          right: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "20px",
          height: "20px",
          padding: "4px",
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: "inherit",
          opacity: 0.5,
          cursor: "pointer",
          "&:hover": {
            opacity: 1,
          },
          "& svg": {
            width: "100%",
            height: "100%",
          },
        })}
      >
        <CloseIcon />
      </button>
    </div>
  );
};
